import { useLegacyCapabilities } from '@apis/rendall/queries/use-capabilities';

import { CONFIGURABLE_ALERTS } from '../alert.constants';

export function useCanManageAlertConfig(alertId?: string) {
  const { data: legacyCapabilities } = useLegacyCapabilities();

  const isConfigurableAlert = alertId ? CONFIGURABLE_ALERTS.has(alertId) : true;

  return !!legacyCapabilities?.canManageAlertConfig && isConfigurableAlert;
}
